export const MULTIPLAN_DISCOUNT_CODE = 'E846h1QP'
export const BULK_DISCOUNT_CODE = 'E145DRWP'
export const FIRST_MONTH_FREE_DISCOUNT_CODE = 'SAVE'

export const PROCESSING_PAYMENT = 'Processing payment ...'

export const MIN_POSTAL_CODE_LENGTH = 5
